export default {
    data() {
        return {
            //下载批量注册模板
            download: this.baseUrl + 'excel/excel_template.xlsx',
            //上传的批量注册excel接口地址
            address: this.baseUrl + 'file/import_users_project?token=' + this.$store.state.authority_management,
            //上传的批量注册excel文件储存
            fileListTwo: [],
            // 批量注册返回的学员信息
            registerInfo:[],
            
        }
    },
    methods: {
		// 上传excel批量注册用户
		httpreq(q){
            // // console.log(q);
			this.$upload(this.address,q).then(res => {
                this.$message({
                    message:'批量注册用户完成，结果如下表',
                    type:'success'
                });
                this.registerInfo=res.data.result;
            })
		},
        //上传excel批量注册的三个方法
        //上传前
        beforeUploadTwo(file) {
            let str = file.name;
            if (str.substr(str.length - 4, 4).toLocaleLowerCase() != "xlsx") {
                alert('excel文件必须是xlsx格式')
                return false;
            }
        },
        //上传超出数量限制
        handleExceedTwo(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        //上传移除
        beforeRemoveTwo(file) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
    }
}
